<template>
  <div>
    <h1 v-if="step !== 5" class="text-center font-poppins-heading">Nová objednávka</h1>
          <NewStep1 @stepConfirmed="step1CompletedFunction" v-if="!hideAllVal && !resetOrderLoader" @orderCanceled="resetOrder"></NewStep1>
          <NewStep2 v-if="step > 2 && !hideAllVal" :key="key"></NewStep2>
          <NewStep3 @deletedDay="rerenderStep2" v-if="step > 2 && !hideAllVal"></NewStep3>
          <NewStep4 @orderCanceled="resetOrder" @finishingOrder="hideAll" v-if="step >= 4" id="step4"></NewStep4>
          <div v-if="finishingOrderLoader && step !== 5" class="text-center">
            <v-progress-linear
              indeterminate
              color="green"
              height="7"
            ></v-progress-linear>
            <h3 class="mt-4">Dokončujeme objednávku, prosím vydržte</h3>
          </div>
          <div v-if="resetOrderLoader" class="text-center">
            <v-progress-linear
              value="100"
              color="red"
              height="7"
            ></v-progress-linear>
            <h3 class="mt-4">Rušíme objednávku, prosím vydržte</h3>
          </div>
          <v-card
            class="my-12"
            color="white"
            flat
            v-if="step === 5"
          >
            <v-card-text id="order-finished" class="d-flex justify-center align-center align-self-center font-readex font-weight-bold">
              <v-icon x-large color="success">mdi-check</v-icon>
              <h3>Objednávka dokončena</h3>
            </v-card-text>
            <v-card-actions class="d-flex justify-center">
              <v-btn class="btn btn-green-gradient px-10 mb-10 font-readex font-weight-bold" @click="finishOrder">Hotovo</v-btn>
            </v-card-actions>
          </v-card>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import NewStep1 from '@/components/forms/user/NewSteps/NewStep1'
import NewStep2 from '@/components/forms/user/NewSteps/NewStep2'
import NewStep3 from '@/components/forms/user/NewSteps/NewStep3'
import NewStep4 from '@/components/forms/user/NewSteps/NewStep4'

export default {
  name: 'CreateOrderForm',
  components: { NewStep4, NewStep3, NewStep2, NewStep1 },
  data () {
    return {
      creditError: false,
      step1Completed: false,
      step3Completed: false,
      hideAllVal: false,
      resetOrderLoader: false,
      finishingOrderLoader: false,
      key: 0,
      time: 0
    }
  },
  computed: {
    cart: {
      get () {
        return this.$store.ordering.state.cart
      },
      set (cart) {
        this.$store.commit('ordering/setCart', cart)
      }
    },
    ...mapGetters({
      currentUser: 'user/currentUser',
      step: 'ordering/step'
    })
  },
  methods: {
    step1CompletedFunction () {
      this.step1Completed = true
      this.$emit('preventRedirect')
    },
    editVal (val) {
      this.loaderVal = val
    },
    hideAll () {
      this.hideAllVal = true
      this.finishingOrderLoader = true
      // document.getElementById('step4').style.visibility = 'hidden'
      // document.getElementById('step4').style.height = '1px'
      document.getElementById('step4').style.display = 'none'
    },
    rerenderStep2 () {
      this.key += 1
    },
    getTimeTypes () {
      this.$http.get('/admin/times')
        .then(response => {
          const timeTypes = this.keysToCamelCase(response.data)
            .filter(time => time.active)
          this.setTimeTypes(timeTypes)
        })
        .catch(err => {
          console.log(err)
        })
    },
    initialize () {
      const shoppingCartInfo = JSON.parse(localStorage.getItem('shoppingCart'))
      if (shoppingCartInfo) {
        this.cart = shoppingCartInfo
      }

      this.getCredit()
    },
    orderFinished () {
      this.finishingOrderLoader = false
      // console.log('pivo')
      this.$emit('order-finished')
    },
    finishOrder () {
      localStorage.removeItem('shoppingCart')
      this.reset()
      location.replace('/user/order-history')
    },
    resetOrder () {
      console.log('test')
      this.finishingOrderLoader = false
      this.resetOrderLoader = true
      localStorage.removeItem('shoppingCart')
      this.reset()
      location.reload()
    },
    resetOrderRedirect () {
      this.resetOrderLoader = true
      localStorage.removeItem('shoppingCart')
      this.reset()
      // location.reload()
    },
    getCredit () {
      this.$http.get(`/users/${this.currentUser.id}`)
        .then(response => {
          this.updateCredit(response.data.credit)

          const tmpUser = Object.assign({}, this.currentUser)
          delete tmpUser.accessToken
          this.setUser(tmpUser)
        })
    },
    ...mapMutations({
      updateCredit: 'user/updateCredit',
      setTimeTypes: 'ordering/updateTimeTypes',
      updateShoppingCartStorage: 'ordering/updateShoppingCartStorage',
      reset: 'ordering/reset',
      setUser: 'ordering/setUser'
    })
  },
  created () {
    this.initialize()
    this.getTimeTypes()
  },
  watch: {
    step (val) {
      this.updateShoppingCartStorage()
      if (val === 5) {
        this.getCredit()
        setTimeout(() => {
          this.finishOrder()
        }, 3500)
      }
    }
  },
  beforeDestroy () {
    this.step = 1
  }
}
</script>

<style scoped>

</style>
